<div class="header">
  <h3>{{'TAX-REPORT.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()"></app-filter-header>

  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="company"
          [options]="company"
          [(ngModel)]="selectedCompany"
          (onChange)="filterBranchList()"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.COMPANY' | translate}}"
          [style]="{'z-index': 3}"
        >
        </p-dropdown>
        <label for="company">{{'FILTER.COMPANY' | translate}}</label>
      </div>
      <div class="dropdown m-t-10" #dd="ngbDropdown" ngbDropdown autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange"
                 ngbDropdownToggle placeholder="{{'FILTER.DATE' | translate}}" readonly>
          <label for="calendarDropdown">{{'FILTER.DATE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="companyBranch"
          [options]="branchList"
          [(ngModel)]="selectedBranch"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.BRANCH' | translate}}"
          [style]="{'z-index': 3}"
        >
        </p-dropdown>
        <label for="companyBranch">{{'FILTER.BRANCH' | translate}}</label>
      </div>

      <div class="dropdown-label-group m-t-10">
        <p-dropdown
          class="dv-dropdown"
          selectId="documentType"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}"
        >
        </p-dropdown>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="row align-items-center" style="height: 50%">
        <div class="col-md-auto">
          <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="notApprove"></p-checkbox>
          <span>{{'TAX-REPORT.FILTER.ITEMS-NOT-CHECKED' | translate}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="errorMsg">
    <div class="col text-center text-red">
      {{ errorMsg }}
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
      [(currentPage)]="currentPage"
      [(itemsPerPage)]="itemsPerPage"
      [totalItems]="totalItems"
      (pageChange)="pageChanged()"
      (optionChange)="searchButtonClicked()"
      *ngIf="no_data === false">
    <button type="button"
        class="btn btn-dv btn-wide"
        (click)="showDownloadLogs()">
      {{'DOWNLOAD-LOGS.TITLE' | translate}}
    </button>
  </app-custom-pagination>

  <div class="d-flex justify-content-end" *ngIf="no_data === true && loading === false">
    <button type="button"
        class="btn btn-dv btn-wide"
        (click)="showDownloadLogs()">
      {{'DOWNLOAD-LOGS.TITLE' | translate}}
    </button>
  </div>

  <div class="row m-t-20" *ngIf="no_data === true && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="m-t-20">
    <p-table #tt class="text-center" tableStyleClass="table" *ngIf="no_data === false" [loading]="loading"
        [columns]="tableCol" [value]="tableData" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
            <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
          </th>
          <th>{{'TAX-REPORT.CORRECT' | translate}}</th>
          <th>{{'COMMON.DOWNLOAD' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.header_issue_display | date:"dd/MM/yyyy"}}</td>
          <td>{{data.corporate_branch__name}}</td>
          <td>{{(currentLang === 'en' ? data.rd_document_type_display : data.rd_document_type_display_th)}}</td>
          <td>{{data.start_end_document}}</td>
          <td>{{data.total_documents}}</td>
          <td>
            <span>
              {{data.total_missing_documents.toLocaleString()}}
            </span>
            <div>
              <button *ngIf="data.total_missing_documents !== 0" style="width: 4rem"
                      class="btn btn-dv btn-clean btn-compact"
                      (click)="downloadMissingDocs(data, index)">
                <i *ngIf="data.loading_missing_docs_excel === true" class="fa fa-spinner fa-spin m-r-5"></i>Excel
              </button>
            </div>
          </td>
          <td *ngIf="data.total_non_vat !== null">
            {{data.total_non_vat.toLocaleString()}}
          </td>
          <td *ngIf="data.total_non_vat === null">
          </td>
          <td *ngIf="data.total_basis_amount !== null">
            {{data.total_basis_amount.toLocaleString()}}
          </td>
          <td *ngIf="data.total_basis_amount === null">
          </td>
          <td *ngIf="data.total_vat !== null">
            {{data.total_vat.toLocaleString()}}
          </td>
          <td *ngIf="data.total_vat === null">
          </td>
          <td class="text-center">
            <i *ngIf="!canUserApproveDoc() && data.approved === true"
                class="fa fa-check m-r-5">
            </i>
            <p-checkbox class="dv-checkbox"
                *ngIf="canUserApproveDoc()"
                [(ngModel)]="data.approved"
                binary="true"
                (click)="confirmDocument($event, content, index)"
                [inputId]="'chkbox' + index">
            </p-checkbox>
          </td>
          <td>
            <button class="btn btn-dv btn-clean btn-compact" style="width: 4rem" (click)="getExportDocs(data, index)">
              <i *ngIf="data.loading_all_docs_excel === true" class="fa fa-spinner fa-spin m-r-5"></i>Excel
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center" *ngIf="modalData.approved">
        <h5>{{'COMMON.APPROVE-TRANSACTION' | translate}}</h5>
      </div>
      <div class="col-12 text-center" *ngIf="!modalData.approved">
        <h5>{{'COMMON.DISAPPROVE-TRANSACTION' | translate}}</h5>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-clean btn-wide"
              (click)="revertBack()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide p-x-100crem" [disabled]="confirm_loading" (click)="confirm()">
        <i *ngIf="confirm_loading" class="fa fa-spinner fa-spin m-r-5"></i>
        {{'COMMON.OK' | translate}}
      </button>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.component.html